/**
 * Global reactive service health status.
 *
 * Tracks whether the backend is reachable. Set to degraded by useApi
 * on repeated 503s, cleared automatically when a request succeeds.
 */

const FAILURE_THRESHOLD = 3
const FAILURE_WINDOW_MS = 10_000

const recentFailures: number[] = []

export function useServiceStatus() {
  const degraded = useState('service-degraded', () => false)

  function recordFailure() {
    const now = Date.now()
    recentFailures.push(now)

    // Evict failures outside the window
    while (recentFailures.length > 0 && recentFailures[0]! < now - FAILURE_WINDOW_MS) {
      recentFailures.shift()
    }

    if (recentFailures.length >= FAILURE_THRESHOLD) {
      degraded.value = true
    }
  }

  function recordSuccess() {
    if (degraded.value) {
      degraded.value = false
    }
    recentFailures.length = 0
  }

  return { degraded: readonly(degraded) as Readonly<Ref<boolean>>, recordFailure, recordSuccess }
}
